import { ApiLocalStorage } from 'utils/ApiLocalStorage';
import { SCHEMA_STORAGE_KEY } from '../services/SchemaService';
import { RouteEnum } from '../constantes/RouteEnum';
import { getTitleFromSchema } from '../utils/getTitleFromSchema';
import routes from './RoutesConfig';
import { getTitleBySignupType } from '../utils/getTitleBySignupType';
import { getDynamicSteps } from '../utils/getDynamicSteps';

type RouteKeys = keyof typeof routes;

export const pageConfigs = {
  welcome: {
    template: 'welcome' as RouteKeys,
    banner: '/images/banner.png',
    buttonLabel: 'Próximo',
    navigateToUserName() {
      return RouteEnum.LOGIN_USERNAME;
    },
    navigateToWelcome() {
      return RouteEnum.WELCOME;
    },
    navigateToRegister() {
      return RouteEnum.LOGIN_USERNAME;
    }
  },
  
  loginUserName: {
    template: 'loginUserName' as RouteKeys,
    title: getTitleFromSchema('Para iniciar, digite seu username.', 'username'),
    buttonLabel: 'Próximo',
    navigateToLoginByOTP() {
      return RouteEnum.OTP_REQUEST;
    },
    navigateToLoginByPassword() {
      return RouteEnum.LOGIN_PASSWORD;
    },
    navigateToOtpRequest() {
      return RouteEnum.OTP_REQUEST
    },
    navigateToRegister() {
      return RouteEnum.PERSONAL;
    },
    navigateBack() {
      return RouteEnum.WELCOME;
    }
  },
  
  loginPassword: {
    template: 'loginPassword' as RouteKeys,
    title: 'Agora, a sua senha.',
    buttonLabel: 'Próximo',
    navigateBack() {
      return RouteEnum.LOGIN_USERNAME;
    },
    navigateToForgotPassword() {
      return RouteEnum.FORGOT_PASSWORD_OTP_REQUEST;
    }
  },
  
  forgotPassword: {
    template: 'forgotPassword' as RouteKeys,
    title: 'Redefinição de senha',
    buttonLabel: 'Enviar código',
    navigateTo() {
      return RouteEnum.VALIDATE_OTP_RESET_PASSWORD;
    },
    navigateBack() {
      return RouteEnum.LOGIN_PASSWORD;
    },
    labelNext: 'Próximo'
  },
  
  validateOtpResetPassword: {
    template: 'validateOtpResetPassword' as RouteKeys,
    title: 'Validação',
    buttonLabel: 'Validar código',
    navigateTo() {
      return RouteEnum.RESET_PASSWORD;
    },
    navigateBack() {
      return RouteEnum.OTP_REQUEST;
    },
    labelNext: 'Validar'
  },
  
  resetPassword: {
    template: 'resetPassword' as RouteKeys,
    title: 'Redefinição de senha',
    buttonLabel: 'Enviar código',
    navigateTo() {
      return RouteEnum.OTP_VALIDATION;
    },
    navigateBack() {
      return RouteEnum.LOGIN_PASSWORD;
    },
    labelNext: 'Próximo'
  },
  
  username: {
    template: 'loginUsername' as RouteKeys,
    title: 'Cadastre sua senha',
    navigateTo() {
      return '/validation/signup';
    },
    navigateBack() {
      const schema = ApiLocalStorage.get(SCHEMA_STORAGE_KEY);
      let redirect = RouteEnum.ADD_INFO;
      
      if (schema.additionalInfo === undefined) {
        redirect = RouteEnum.ADDRESS;
      }
      
      if (schema.address === undefined) {
        redirect = RouteEnum.CONTACT;
      }
      
      return redirect;
    },
    labelNext: 'Próximo'
  },
  
  otpRequest: {
    template: 'otpValidation' as RouteKeys,
    title: 'Agora, selecione uma opção.',
    buttonLabel: 'Enviar código',
    navigateTo() {
      return RouteEnum.OTP_VALIDATION;
    },
    navigateBack() {
      return RouteEnum.LOGIN_USERNAME;
    }
  },
  
  otpValidation: {
    template: 'otpValidate' as RouteKeys,
    title: 'Validação',
    buttonLabel: 'Enviar código',
    navigateTo() {
      return RouteEnum.PERSONAL;
    },
    navigateBack() {
      return RouteEnum.OTP_REQUEST;
    }
  },
  
  personal: {
    template: 'personal' as RouteKeys,
    get totalSteps() {
      return getDynamicSteps('personal').totalSteps;
    },
    get currentStep() {
      return getDynamicSteps('personal').currentStep;
    },
    title: getTitleBySignupType(),
    navigateTo() {
      return RouteEnum.CONTACT;
    },
    navigateBack() {
      return RouteEnum.LOGIN_USERNAME;
    },
    labelNext: 'Próximo'
  },
  
  contact: {
    template: 'contact' as RouteKeys,
    get totalSteps() {
      return getDynamicSteps('contact').totalSteps;
    },
    get currentStep() {
      return getDynamicSteps('contact').currentStep;
    },
    title: 'Contato',
    navigateTo() {
      const schema = ApiLocalStorage.get(SCHEMA_STORAGE_KEY);
      
      let redirect = RouteEnum.ADDRESS;
      
      if (schema.address !== undefined) {
        redirect = RouteEnum.ADDRESS;
      }
      
      if (schema.address === undefined) {
        redirect = RouteEnum.ADD_INFO;
      }
      
      if (schema.additionalInfo === undefined) {
        redirect = RouteEnum.OTP_REQUEST;
      }
      
      return redirect
    },
    
    navigateBack() {
      return RouteEnum.PERSONAL;
    },
    labelNext: 'Próximo'
  },
  
  address: {
    template: 'address' as RouteKeys,
    get totalSteps() {
      return getDynamicSteps('address').totalSteps;
    },
    get currentStep() {
      return getDynamicSteps('address').currentStep;
    },
    title: 'Endereço',
    navigateTo() {
      const schema = ApiLocalStorage.get(SCHEMA_STORAGE_KEY);
      let redirect = RouteEnum.ADD_INFO;
      
      if (schema.additionalInfo === undefined) {
        redirect = RouteEnum.RESET_PASSWORD;
      }
      
      return redirect
    },
    navigateBack() {
      return RouteEnum.CONTACT;
    },
    labelNext: 'Próximo'
  },
  
  additionalInfo: {
    template: 'additionalInfo' as RouteKeys,
    get totalSteps() {
      return getDynamicSteps('additionalInfo').totalSteps;
    },
    get currentStep() {
      return getDynamicSteps('additionalInfo').currentStep;
    },
    title: 'Informações Adicionais',
    navigateTo() {
      return RouteEnum.CREATE_PASSWORD_ONBOARDING;
    },
    navigateBack() {
      const schema = ApiLocalStorage.get(SCHEMA_STORAGE_KEY);
      let redirect = RouteEnum.ADDRESS;
      
      if (schema.address === undefined) {
        redirect = RouteEnum.PERSONAL;
      }
      
      return redirect
    },
    labelNext: 'Próximo'
  },
  
  createPassword: {
    get totalSteps() {
      return getDynamicSteps('createPassword').totalSteps;
    },
    get currentStep() {
      return getDynamicSteps('createPassword').currentStep;
    },
    template: 'createPassword',
    title: 'Agora, crie sua senha',
    buttonLabel: 'Registrar',
    navigateTo() {
      return RouteEnum.FINISH;
    },
    navigateBack() {
      const schema = ApiLocalStorage.get(SCHEMA_STORAGE_KEY);
      let redirect = RouteEnum.ADD_INFO;
      
      if (schema.additionalInfo === undefined) {
        redirect = RouteEnum.ADDRESS;
      }
      
      if (schema.address === undefined) {
        redirect = RouteEnum.CONTACT;
      }
      
      return redirect
    }
  },
  
  finish: {
    get totalSteps() {
      return getDynamicSteps('finish').totalSteps;
    },
    get currentStep() {
      return getDynamicSteps('finish').currentStep;
    },
    title: 'Cadastro concluído com sucesso!',
    description: 'Cadastro concluído com sucesso!',
    navigateTo() {
      return RouteEnum.HOME;
    },
    navigateBack() {
      return '/';
    },
    labelNext: 'Entrar',
    confetti: true
  },
  
  password: {
    title: 'Agora, a sua senha',
    navigateTo() {
      return '/';
    },
    navigateBack() {
      return '/home';
    },
    labelNext: 'Próximo'
  },
  
  // Validation
  signupValidation: {
    title: 'Validação',
    description: 'Selecione por onde deseja validar sua conta',
    navigateBack() {
      return RouteEnum.OTP_REQUEST;
    },
    navigateTo() {
      return '/code/signup';
    },
    labelNext: 'Próximo'
  },
  passwordValidation: {
    title: 'Validação',
    description: 'Selecione por onde deseja validar sua conta',
    navigateBack() {
      return '/login';
    },
    navigateTo() {
      return '/code/password';
    },
    labelNext: 'Próximo'
  },
  signupValidationCode: {
    title: 'Validação',
    navigateBack() {
      return '/validation/signup';
    },
    navigateTo() {
      return '/finish';
    },
    labelNext: 'Próximo',
    description: 'Digite o código enviado'
  },
  passwordValidationCode: {
    title: 'Validação',
    navigateBack() {
      return '/validation/password';
    },
    navigateTo() {
      return '/reset-password';
    },
    labelNext: 'Próximo',
    description: 'Digite o código enviado'
  },
  twoFactorValidation: {
    title: 'Validação',
    navigateBack() {
      return '/otp';
    },
    navigateTo() {
      return '/finish';
    },
    labelNext: 'Próximo',
    description: 'Selecione um contato para fazer login'
  },
  twoFactorValidationCode: {
    title: 'Validação',
    navigateBack() {
      return '/validation/otp';
    },
    navigateTo() {
      return '/home';
    },
    labelNext: 'Próximo',
    description: 'Digite o código enviado'
  },
  otp: {
    title: 'LoginPassword por OTP',
    navigateTo() {
      return '/validation/otp';
    },
    navigateBack() {
      return '/';
    },
    labelNext: 'Próximo'
  }
};
